import React from "react";
import { Box, Container, Heading, Text, UnorderedList, ListItem, Link } from "@chakra-ui/react";

const brand = { green: "#1C4C3F", ink: "#0E2721" };

export default function TermsPage() {
  return (
    <Box bg="#F7F5EB" color={brand.ink}>
      <Container maxW="4xl" px={{ base: 4, md: 6 }} py={{ base: 10, md: 14 }}>
        <Heading size="lg" mb={2}>ShelfKey Terms & Conditions</Heading>
        <Text fontSize="sm" opacity={0.7} mb={8}>Last updated: {new Date().toLocaleDateString()}</Text>

        <Heading size="md" mt={6} mb={2}>1. Overview</Heading>
        <Text mb={4}>
          ShelfKey (“we,” “us,” “our”) provides tools that generate charts, insights, and AI-assisted
          guidance for the consumer packaged goods (CPG) industry. By using ShelfKey, you agree to these Terms.
        </Text>

        <Heading size="md" mt={6} mb={2}>2. No Professional Advice</Heading>
        <Text mb={4}>
          Outputs are generated by software and/or AI models and are provided for{" "}
          <strong>informational purposes only</strong>. They do not constitute financial, legal, medical,
          regulatory, or professional advice. You are solely responsible for decisions made using the Service.
        </Text>

        <Heading size="md" mt={6} mb={2}>3. Your Responsibilities</Heading>
        <UnorderedList mb={4}>
          <ListItem>Provide accurate, lawful inputs and data.</ListItem>
          <ListItem>Evaluate outputs and exercise independent judgment.</ListItem>
          <ListItem>Comply with applicable laws, retailer/platform policies, and data rights.</ListItem>
        </UnorderedList>

        <Heading size="md" mt={6} mb={2}>4. Data & Privacy</Heading>
        <Text mb={4}>
          We process your content to operate the Service. See our{" "}
          <Link href="/privacy" color={brand.green} textDecoration="underline">Privacy Policy</Link>{" "}
          for details on data handling, retention, and deletion controls.
        </Text>

        <Heading size="md" mt={6} mb={2}>5. Acceptable Use</Heading>
        <UnorderedList mb={4}>
          <ListItem>No unlawful, infringing, or harmful content.</ListItem>
          <ListItem>No attempts to reverse engineer or abuse rate limits.</ListItem>
          <ListItem>No sharing of output that violates third-party rights or confidentiality.</ListItem>
        </UnorderedList>

        <Heading size="md" mt={6} mb={2}>6. Intellectual Property</Heading>
        <Text mb={4}>
          We own the Service and underlying technology. As between you and us, you own your input data.
          Subject to these Terms, you may use outputs for your internal business purposes.
        </Text>

        <Heading size="md" mt={6} mb={2}>7. Disclaimers</Heading>
        <Text mb={4}>
          THE SERVICE IS PROVIDED “AS IS” AND “AS AVAILABLE.” WE DISCLAIM ALL WARRANTIES, EXPRESS OR IMPLIED,
          INCLUDING ACCURACY, RELIABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT.
        </Text>

        <Heading size="md" mt={6} mb={2}>8. Limitation of Liability</Heading>
        <Text mb={4}>
          TO THE MAXIMUM EXTENT PERMITTED BY LAW, WE WILL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL,
          CONSEQUENTIAL, EXEMPLARY, OR PUNITIVE DAMAGES, OR FOR LOST PROFITS, REVENUE, DATA, OR GOODWILL.
          OUR TOTAL LIABILITY FOR ANY CLAIM RELATING TO THE SERVICE WILL NOT EXCEED THE AMOUNTS YOU PAID IN
          THE 3 MONTHS PRECEDING THE EVENT GIVING RISE TO THE CLAIM.
        </Text>

        <Heading size="md" mt={6} mb={2}>9. Termination</Heading>
        <Text mb={4}>
          You may stop using the Service at any time. We may suspend or terminate access for violations of
          these Terms or to protect the Service or other users.
        </Text>

        <Heading size="md" mt={6} mb={2}>10. Changes</Heading>
        <Text mb={4}>
          We may update these Terms. Material changes will be posted here with a new effective date.
          Continued use after changes constitutes acceptance.
        </Text>

        <Heading size="md" mt={6} mb={2}>11. Contact</Heading>
        <Text>
          Questions? Email{" "}
          <Link href="mailto:hello@shelfkey.app" color={brand.green} textDecoration="underline">
            hello@shelfkey.app
          </Link>.
        </Text>
      </Container>
    </Box>
  );
}
